var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'v-page',
    {
      '--no-scroll': _vm.noInnerScroll,
      '--no-bottom-padding': _vm.noPadding,
      '--white': _vm.white,
      '--dark-mode': _vm.darkMode
    }
  ],attrs:{"id":_vm.pageId}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }